/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type MoneyRaisedContainer_app$ref = any;
type UserMenuContainer_app$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type DashboardContainer_app$ref: FragmentReference;
export type DashboardContainer_app = {|
  +isGlobalCampaignLive: ?boolean,
  +$fragmentRefs: MoneyRaisedContainer_app$ref & UserMenuContainer_app$ref,
  +$refType: DashboardContainer_app$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "DashboardContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isGlobalCampaignLive",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "MoneyRaisedContainer_app",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserMenuContainer_app",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '2458d86b995bfab1ffd24dc399e13e2e';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Dashboard/__generated__/DashboardContainer_app.graphql.js